// extracted by mini-css-extract-plugin
export default {"frame":"recentes_frame__rQOro","frameSquare":"recentes_frameSquare__l3AOK","imagem":"recentes_imagem__ETesY","marca":"recentes_marca__ZcqI5","modelo":"recentes_modelo__GD2Q6"};